jQuery(document).ready(function ($) {
  $('.faq-sec accordion-custom details').on('click', function (e) {
    const $current = $(this);
    if ($current.attr('open') !== undefined) {
      return;
    }
    $('.faq-sec accordion-custom').each(function(){
        $(this).find('details').not($current).removeAttr('open');
    });
    // $('.faq-sec accordion-custom details[open]').not($current).removeAttr('open');
  });


  $('.product-details accordion-custom details').on('click', function (e) {
    const $current = $(this);
    if ($current.attr('open') !== undefined) {
      return;
    }
    $('.product-details accordion-custom').each(function(){
        $(this).find('details').not($current).removeAttr('open');
    });
    // $('.product accordion-custom details[open]').not($current).removeAttr('open');
  });

  document.addEventListener("scroll", function () {
    const heroSection = document.querySelector(".hero.hero_banner.index_banner");
    const button = heroSection ? heroSection.querySelector(".button") : null;
    if (!heroSection || !button) return;

    const rect = heroSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const bottomThreshold = viewportHeight * 0.7; // 30% from bottom

    // When hero top reaches top but bottom not yet hit threshold → animate down
    if (rect.top <= 0 && rect.bottom > bottomThreshold) {
      button.classList.add("scroll_animate");
      button.classList.remove("scroll_fixed");
    }
    // When hero bottom reaches threshold → fix at bottom
    else if (rect.bottom <= bottomThreshold) {
      button.classList.add("scroll_fixed");
      button.classList.remove("scroll_animate");
    }
    // When scrolling back up → reset
    else {
      button.classList.remove("scroll_animate", "scroll_fixed");
    }
  });



});
